import React, { useState, useEffect } from 'react';
import apiService from '../../services/api';
import './Products.css';

const ContactPurchasesModal = ({ contact, onClose, type = 'supplier' }) => {
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (contact) {
      fetchData();
    }
  }, [contact]);

  const fetchData = async () => {
    setLoading(true);
    try {
      let data;
      if (type === 'supplier') {
        data = await apiService.getPurchases({ supplier_id: contact.id, per_page: 100 });
      } else {
        data = await apiService.getSales({ contact_id: contact.id, per_page: 100 });
      }
      
      let list = [];
      if (data.success && data.data) {
        list = Array.isArray(data.data) ? data.data : (data.data.data || []);
      } else {
        list = Array.isArray(data) ? data : (data.data || []);
        if (!Array.isArray(list) && list.data) {
          list = list.data;
        }
      }
      setPurchases(Array.isArray(list) ? list : []);
    } catch (error) {
      console.error(`Failed to fetch ${type === 'supplier' ? 'purchases' : 'sales'}`, error);
    } finally {
      setLoading(false);
    }
  };

  const isSupplier = type === 'supplier';
  const title = isSupplier ? 'Purchases' : 'Sales';

  return (
    <div className="modal-overlay" onClick={onClose} style={{ zIndex: 9999 }}>
      <div className="modal-container" style={{ maxWidth: '900px', width: '95%', maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title} - {contact.name || contact.supplier_business_name || contact.business_name}</h2>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>
        <div style={{ padding: '1.5rem' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '2rem' }}>Loading {title.toLowerCase()}...</div>
          ) : purchases.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '2rem', color: '#64748b' }}>No {title.toLowerCase()} found for this contact.</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table className="products-table" style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
                <thead>
                  <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                    <th style={{ padding: '10px', textAlign: 'left' }}>Date</th>
                    <th style={{ padding: '10px', textAlign: 'left' }}>Reference No</th>
                    <th style={{ padding: '10px', textAlign: 'left' }}>Location</th>
                    <th style={{ padding: '10px', textAlign: 'left' }}>Status</th>
                    <th style={{ padding: '10px', textAlign: 'left' }}>Payment Status</th>
                    <th style={{ padding: '10px', textAlign: 'right' }}>Grand Total</th>
                    <th style={{ padding: '10px', textAlign: 'right' }}>Payment Due</th>
                  </tr>
                </thead>
                <tbody>
                  {purchases.map(p => (
                    <tr key={p.id} style={{ borderBottom: '1px solid #e2e8f0' }}>
                      <td style={{ padding: '10px' }}>{p.transaction_date}</td>
                      <td style={{ padding: '10px' }}>{p.ref_no || p.invoice_no}</td>
                      <td style={{ padding: '10px' }}>{p.location?.name || '--'}</td>
                      <td style={{ padding: '10px' }}><span className={`status-badge ${p.status?.toLowerCase()}`}>{p.status}</span></td>
                      <td style={{ padding: '10px' }}><span className={`status-badge ${p.payment_status?.toLowerCase()}`}>{p.payment_status}</span></td>
                      <td style={{ padding: '10px', textAlign: 'right' }}>${parseFloat(p.final_total || 0).toFixed(2)}</td>
                      <td style={{ padding: '10px', textAlign: 'right', color: p.payment_due > 0 ? '#ef4444' : 'inherit', fontWeight: p.payment_due > 0 ? 600 : 400 }}>
                        ${parseFloat(p.payment_due || 0).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="modal-footer" style={{ borderTop: '1px solid #e2e8f0', padding: '1rem 2rem', display: 'flex', justifyContent: 'flex-end' }}>
          <button style={{ padding: '0.6rem 1.5rem', background: '#64748b', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }} onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default ContactPurchasesModal;
